import React, { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineUpload, AiOutlineTrophy } from "react-icons/ai";
import { toast } from "react-toastify";
import axiosInstance from "../ManageContent/managecontentforms/axiosInstance";
import "./ActivityList.css";

// Add Modal component
const RemarksModal = ({
  isOpen,
  onClose,
  remarks,
  textColor,
  backgroundColor,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: backgroundColor,
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "500px",
          width: "90%",
          color: textColor,
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            border: "none",
            background: "none",
            fontSize: "18px",
            cursor: "pointer",
            color: textColor,
          }}
          onClick={onClose}
        >
          ×
        </button>
        <h3>Remarks</h3>
        <p>{remarks}</p>
      </div>
    </div>
  );
};

const ActivityList = React.memo(
  ({
    title,
    projects,
    backgroundColor,
    textColor,
    iconBackground,
    image,
    image1,
    courseID,
    activityID,
    uploadApiRoute,
    studentId,
    setRefresh = null,
    profileData,
  }) => {
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState("");

    // Determine if time display is needed
    const shouldDisplayTime = [
      "Mental",
      "Oral",
      "Written",
      "Speed Quiz",
      "MCQ",
    ].includes(title);

    // Handle project click
    const handleProjectClick = useCallback(
      async (projectType, activityID, activityLink = null, project) => {
        let route = "";

        const updateActivity = async (activityID) => {
          try {
            const courseIDResponse = await axiosInstance.post(
              "/getActivitycompletefromStudentIF",
              {
                Activity_id: activityID,
                StudentId: studentId,
              }
            );
            // Trigger refresh of parent component
            setRefresh((prev) => !prev);
          } catch (error) {
            console.error("Error updating activity status:", error);
          }
        };

        if (projectType === "MCQ") {
          route = "/ActivityStartPage?activityType=MCQActivity";
          const queryParams = new URLSearchParams({
            activityId: activityID,
            studentId: studentId,
            onComplete: "refresh",
          }).toString();
          window.open(`${route}&${queryParams}`, "_blank");
        } else if (projectType === "Written") {
          route = "/ActivityStartPage?activityType=WrittenActivity";
          const queryParams = new URLSearchParams({
            activityId: activityID,
            studentId: studentId,
            onComplete: "refresh",
          }).toString();
          window.open(`${route}&${queryParams}`, "_blank");
        } else if (projectType === "Video") {
          // alert("Video");
          route = "/VideoActivity?";
          await updateActivity(activityID);
          window.open(
            `${route}&activityId=${activityID}&modulename=${profileData.modulename}&lessonname=${profileData.lessonname}`,
            "_blank"
          );
        } else if (projectType === "Speed Quiz") {
          route = "/ActivityStartPage?activityType=SpeedQuizActivity";
          const queryParams = new URLSearchParams({
            activityId: activityID,
            studentId: studentId,
            onComplete: "refresh",
          }).toString();
          window.open(`${route}&${queryParams}`, "_blank");
        } else if (projectType === "Mental") {
          route = "/ActivityStartPage?activityType=MentalActivity";
          const queryParams = new URLSearchParams({
            activityId: activityID,
            studentId: studentId,
            onComplete: "refresh",
          }).toString();
          window.open(`${route}&${queryParams}`, "_blank");
        } else if (projectType === "Oral") {
          route = "/ActivityStartPage?activityType=OralActivity";
          const queryParams = new URLSearchParams({
            activityId: activityID,
            studentId: studentId,
            onComplete: "refresh",
          }).toString();
          window.open(`${route}&${queryParams}`, "_blank");
        } else if (projectType === "Game") {
          await updateActivity(activityID);
          window.open(activityLink, "_blank");
        }
      },
      [studentId, setRefresh]
    );

    // Handle file selection
    const handleFileSelect = useCallback(async (e, projectID) => {
      const file = e.target.files[0];
      setSelectedFile(file);
      await handleUpload(file, projectID);
    }, []);

    // Handle file upload
    const handleUpload = useCallback(
      async (file, projectID) => {
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("Student_id", studentId);
          formData.append("Activity_id", projectID);

          const response = await fetch(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}${uploadApiRoute}`,
            {
              method: "POST",
              body: formData,
            }
          );

          if (response.ok) {
            toast.success("Game Activity Uploaded", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setSelectedFile(null);
          } else {
            throw new Error("Upload failed");
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          toast.error("Error uploading file");
        }
      },
      [uploadApiRoute, studentId]
    );

    const handleRemarksClick = useCallback((remarks) => {
      setSelectedRemarks(remarks);
      setIsModalOpen(true);
    }, []);

    // Add navigation handler for leaderboard
    const handleLeaderboardClick = (activityId) => {
      window.open(
        `/leaderboard?studentId=${studentId}&activityId=${activityId}`,
        "_blank"
      );
    };

    return (
      // <div className="activity-row">
      <div className="AP_ModuleProjectLesson" style={{ backgroundColor }}>
        <h2 className="AP_title" style={{ color: "#812470" }}>
          <div>
            <img
              src={image}
              alt=""
              style={{
                width: 66,
                height: 59,
                top: 39,
                left: 55,
                angle: 0,
                opacity: 1,
              }}
            />{" "}
            {title} Activities
          </div>
          <img
            src={image1}
            alt=""
            style={{
              width: 100,
              height: 100,
            }}
          />
        </h2>
        <ul className="AP_ActivitiesGrid">
          {projects.map((project, index) => {
            const {
              Activity_id,
              Lesson_Activity_id,
              ActivityName,
              MarksObtained,
              TotalMarks,
              TimeTaken,
              TotalTime,
              Complete,
              Remarks,
            } = project.activity;
            const projectID = Activity_id || Lesson_Activity_id;

            return (
              <li key={index} className="AP_Projects">
                <div
                  className="AP_ProjectItem"
                  style={{ position: "relative" }}
                >
                  <div style={{ marginBottom: "5px", position: "relative" }}>
                    <Link
                      to=""
                      onClick={() =>
                        handleProjectClick(
                          title,
                          projectID,
                          project?.activity?.ActivityLink,
                          project
                        )
                      }
                      style={{
                        marginRight: "40px",
                        color: textColor,
                        fontStyle: "bold",
                        fontWeight: "700",
                        textDecoration: "underline",
                        display: "block",
                        paddingRight: "30px",
                      }}
                    >
                      {ActivityName}
                    </Link>
                    <span
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        backgroundColor:
                          (MarksObtained / TotalMarks) * 100 > 75
                            ? "#4CAF50"
                            : title == "Video" && Complete
                            ? "#4CAF50"
                            : "#ccc",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        zIndex: 1,
                      }}
                    >
                      ✓
                    </span>
                  </div>
                  {shouldDisplayTime ? (
                    <div className="AP_ProjectDetails">
                      <span className="AP_Score">
                        &#x1F4CA;
                        {MarksObtained}/{TotalMarks}
                        <span>
                          (
                          {TotalMarks > 0
                            ? ((MarksObtained / TotalMarks) * 100).toFixed(1)
                            : "0"}
                          %)
                        </span>
                      </span>
                      <span className="AP_Time">
                        &#x1F550;
                        {(TimeTaken / 60).toFixed(0)}/
                        {(TotalTime / 60).toFixed(0)}
                        <span>Min</span>
                      </span>
                      {Remarks && (
                        <span
                          className="AP_Feedback"
                          onClick={() => handleRemarksClick(Remarks)}
                          title="Click to view remarks"
                        >
                          &#x1F4AC; Remarks
                        </span>
                      )}

                      {title === "Speed Quiz" && (
                        <span
                          className="AP_Score"
                          onClick={() => handleLeaderboardClick(projectID)}
                          title="View Leaderboard"
                        >
                          <AiOutlineTrophy size={20} />
                        </span>
                      )}
                    </div>
                  ) : title !== "Video" && title !== "MCQ" ? (
                    <label htmlFor={`Gfile-upload-${index}`}>
                      <span className="AP_Icon">
                        <AiOutlineUpload size={20} /> Upload
                      </span>
                      <input
                        id={`Gfile-upload-${index}`}
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => handleFileSelect(e, projectID)}
                      />
                    </label>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>

        <RemarksModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          remarks={selectedRemarks}
          textColor={textColor}
          backgroundColor={backgroundColor}
        />
      </div>
      // </div>
    );
  }
);

export default ActivityList;
